<template>
  <div class="d-flex justify-content-center align-items-center spinner-page">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "loading-spinner",
};
</script>

<style scoped>
.spinner-page {
  height: calc(100vh - 60px);
}
</style>
